import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    selectedFilters: {},
    searchQuery: '',
};
const searchFilterSlice = createSlice({
    name: 'searchFilter',
    initialState,
    reducers: {
        setSearchQuery: (state, action) => {
            state.searchQuery = action.payload;
        },
        searchQueryChanged(state, action) {
        },
        setSelectedFilters: (state, action) => {
            const {category, value, dataset} = action.payload;
            if (!state.selectedFilters[dataset]) {
                state.selectedFilters[dataset] = {};
            }
            if (!state.selectedFilters[dataset][category]) {
                state.selectedFilters[dataset][category] = [];
            }

            const categoryFilters = state.selectedFilters[dataset][category];
            if (categoryFilters.includes(value)) {
                state.selectedFilters[dataset][category] = categoryFilters.filter(
                    (item) => item !== value
                );
            } else {
                categoryFilters.push(value);
            }
        },
        resetFiltersAndSearch: (state,action) => {
            const dataset = action.payload;
            state.searchQuery = '';
            if (dataset) {
                state.selectedFilters[dataset] = {};
            }
        },
    },
});

export const {
    setSearchQuery,
    setSelectedFilters,
    searchQueryChanged,
    resetFiltersAndSearch
} = searchFilterSlice.actions;

export default searchFilterSlice.reducer;
